import { render } from "./ProductReviewListPage.vue?vue&type=template&id=c49d8fd6"
import script from "./ProductReviewListPage.vue?vue&type=script&lang=js"
export * from "./ProductReviewListPage.vue?vue&type=script&lang=js"
script.render = render

export default script